<template>
  <div>
    <a @click="fnShowModal()" class="p-2"
      ><i class="far fa-edit text-primary"></i
    ></a>

    <b-modal ref="modal" hide-footer title="Forms - update">
      <div class="d-block">
        <form>
          <div class="form-group">
            <label for="title">Question</label>
            <textarea
              type="text"
              rows="3"
              class="form-control type2"
              id="title"
              placeholder="Question"
              v-model="title"
            ></textarea>
            <div class="invalid-feedback" v-if="errors.title">
              {{ errors.title[0] }}
            </div>
          </div>
          <div class="form-group">
            <label for="description">Answer</label>
            <vue-editor v-model="description" :editor-toolbar="customToolbar" />
            <div class="invalid-feedback" v-if="errors.description">
              {{ errors.description[0] }}
            </div>
          </div>

          <b-form-checkbox
            id="checkbox-1"
            v-model="status"
            name="checkbox-1"
            value="1"
            unchecked-value="0"
          >
            Status
          </b-form-checkbox>
          <hr />
          <div class="text-right">
            <button
              type="button"
              class="btn btn-secondary btn-sm mr-2"
              @click="hideModal"
            >
              Cancel
            </button>
            <button
              type="button"
              @click="fnUpdate()"
              class="btn btn-primary btn-sm"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import * as messageService from '../../services/message.service'
import * as faqService from '../../services/faq.service'
export default {
  name: 'ModalFaqEdit',
  props: ['propsData'],
  components: {},
  data() {
    return {
      errors: {},
      id: '',
      title: '',
      description: '',
      status: '',
      customToolbar: [
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        ['blockquote', 'code-block'],
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }]
      ]
    }
  },
  computed: {
    ...mapGetters(['gettFaqAll'])
  },
  methods: {
    ...mapActions(['fetchFaqAll']),
    fnShowModal() {
      this.fnGetValue(this.propsData)
      this.showModal()
    },
    hideModal() {
      this.$refs.modal.hide()
    },
    showModal() {
      this.$refs.modal.show()
    },

    fnGetValue(props) {
      this.id = props.rowData.id
      this.title = props.rowData.title
      this.description = props.rowData.description
      this.status = props.rowData.status
    },
    fnUpdate: async function () {
      let obj = {
        title: this.title,
        description: this.description,
        status: this.status
      }

      try {
        const response = await faqService.update(this.id, obj)

        this.fetchFaqAll()
        messageService.fnSweetAlertSuccessToast('Faq', 'Updated successfully')

        this.hideModal()

        this.id = ''
        this.title = ''
        this.description = ''
        this.status = ''
      } catch (error) {
        messageService.fnSweetAlertErrorToast(
          'Faq - update',
          error.response.data.message
        )
      }
    }
  }
}
</script>